const posTerminalNameLabel = {
  sadad: "سداد"
}

export default posTerminalNameLabel